var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g, _path68, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThirdFormat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 304,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thirdFormat_svg__clip0_632_9274)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.492 161.853a6.868 6.868 0 100-13.736 6.868 6.868 0 000 13.736z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.588 168.81a6.868 6.868 0 100-13.737 6.868 6.868 0 000 13.737z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.351 176.157a6.868 6.868 0 100-13.736 6.868 6.868 0 000 13.736zM242.516 150.868a6.868 6.868 0 100-13.736 6.868 6.868 0 000 13.736z",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.763 155.54a6.868 6.868 0 100-13.736 6.868 6.868 0 000 13.736z",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.77 160.343a6.868 6.868 0 10.001-13.737 6.868 6.868 0 00-.001 13.737zM244.754 139.37c-6.557 16.434-26.819 23.797-45.255 16.441-18.44-7.355-26.234-25.583-19.676-42.017 6.557-16.434 24.69-25.848 37.949-19.273 27.943 4.456 33.54 28.412 26.982 44.849z",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.614 106.414l-6.759 11.692 20.481 14.986",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.614 106.414l-6.759 11.692 20.481 14.986",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.182 156.366s6.017 9.185 2.005 19.217c-.402 12.843 4.616 14.848 4.616 14.848l20.396-15.802s-4.026-9.124 0-20.629",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.182 156.366s6.017 9.185 2.005 19.217c-.402 12.843 4.616 14.848 4.616 14.848l20.396-15.802s-4.026-9.124 0-20.629",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.246 112.398s-.654 1.067-1.642 2.91c-5.181 9.644-19.623 40.549 1.702 51.005 14.545 7.133 33.429-9.365 33.429-9.365s9.054 4.993 14.814-2.652c7.309-9.7-7.137-19.365-13.963-10.541",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.246 112.398s-.654 1.067-1.642 2.91c-5.181 9.644-19.623 40.549 1.702 51.005 14.545 7.133 33.429-9.365 33.429-9.365s9.054 4.993 14.814-2.652c7.309-9.7-7.137-19.365-13.963-10.541",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.773 149.887s5.693-6.557 11.328-2.133l-11.328 2.133z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.773 149.887s5.693-6.557 11.328-2.133",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.525 206.989l-4.767 58.78a12.69 12.69 0 01-1.724 5.527c-3.492 5.925-11.6 20.205-8.418 19.711 3.189-.495 8.002-7.501 9.841-10.354.163-.251.551-.099.498.198-.992 5.509-4.396 25.368-1.603 23.327 3.242-2.366 5.851-17.956 5.851-17.956s-3.277 20.491.41 20.512c2.564.015 4.965-19.05 4.965-19.05s-2.017 20.745 1.091 19.803c3.001-.911 2.818-19.32 2.818-19.32s-.463 11.54 2.627 10.749c2.726-.695-.117-25.717-.826-31.6a10.475 10.475 0 010-2.49l8.771-61.167",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M166.525 206.989l-4.767 58.78a12.69 12.69 0 01-1.724 5.527c-3.492 5.925-11.6 20.205-8.418 19.711 3.189-.495 8.002-7.501 9.841-10.354.163-.251.551-.099.498.198-.992 5.509-4.396 25.368-1.603 23.327 3.242-2.366 5.851-17.956 5.851-17.956s-3.277 20.491.41 20.512c2.564.015 4.965-19.05 4.965-19.05s-2.017 20.745 1.091 19.803c3.001-.911 2.818-19.32 2.818-19.32s-.463 11.54 2.627 10.749c2.726-.695-.117-25.717-.826-31.6a10.475 10.475 0 010-2.49l8.771-61.167",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.743 154.318s5.117-2.808 4.107-8.097l-4.107 8.097z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M225.743 154.318s5.117-2.808 4.107-8.097",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.26 124.006s11.045-2.648 10.752 7.595c-.293 10.244-9.386 11.777-9.386 11.777l1.127 5.385",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M183.26 124.006s11.045-2.648 10.752 7.595c-.293 10.244-9.386 11.777-9.386 11.777l1.127 5.385",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M182.495 151.709s.417 5.547 7.61 3.535l-7.61-3.535z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M182.495 151.709s.417 5.547 7.61 3.535",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201.297 129.444s6.953-1.469 11.324 7.504l-11.324-7.504z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M201.297 129.444s6.953-1.469 11.324 7.504",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M182.661 129.007s5.996-2.016 8.471 5.872l-8.471-5.872z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M182.661 129.007s5.996-2.016 8.471 5.872",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M198.545 137.322s5.996-2.017 8.471 5.872l-8.471-5.872z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.545 137.322s5.996-2.017 8.471 5.872",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188.079 107.718s8.567 31.618 33.508 36.043c2.736-12.84-6.897-32.448-6.897-32.448l-23.599-9.626-3.012 6.031zM220.753 99.213s-15.58-9.212.689-18.08c-4.34 8.772-.689 18.08-.689 18.08zM246.983 173.416c-.346.202-.435 11.42 13.372 8.948-5.314-1.995-2.691-10.72-10.653-11.748-7.624.488-2.719 2.804-2.719 2.804v-.004zM259.764 157.46c-.243.318 3.909 10.739 15.763 3.235-5.674.159-6.539-8.909-14.301-6.858-6.875 3.33-1.462 3.623-1.462 3.623z",
    fill: "#333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M194.633 172.217l4.919 13.239 19.202-15.375s34.179 8.877 33.455 46.255l-31.417 6.529-7.328 1.522-50.231-15.95s1.974-32.685 31.4-36.216v-.004z",
    fill: "#16C8BB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M173.407 197.232l-10.174 116.102s43.808 19.782 88.986 0l-11.688-100.55-67.124-15.552z",
    fill: "#16C8BB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M193.655 231.834a5.344 5.344 0 001.826 7.341l27.886 16.787-9.676 7.458a13.182 13.182 0 00-11.314-1.172 13.117 13.117 0 00-5.869 4.184l-13.987-10.893c-2.242-1.748-5.529-.933-6.695 1.67l-2.489 5.561c-1.254 2.804.685 5.993 3.75 6.173l17.409 1.01a13.162 13.162 0 00-.117 9.174 13.166 13.166 0 004.675 6.247l-12.285 11.095c-2.111 1.91-1.878 5.293.477 6.889l5.046 3.411c2.543 1.72 6.017.371 6.724-2.62l3.983-16.812a13.201 13.201 0 0016.723-9.923l11.007-.664-2.055 27.734a5.358 5.358 0 004.937 5.731 5.36 5.36 0 005.731-4.94l2.164-29.174 49.67-2.988c4.075-.247 6.695-4.421 5.145-8.196l-3.613-8.799 19.991-9.693a5.34 5.34 0 002.478-7.14 5.345 5.345 0 00-7.14-2.483l-19.396 9.407-2.289-5.579 17.858-8.659a5.342 5.342 0 002.478-7.143 5.34 5.34 0 00-7.14-2.479l-17.264 8.365-3.326-8.097c-1.494-3.626-6.024-4.844-9.135-2.45L232.47 248.96l-31.466-18.938a5.346 5.346 0 00-7.342 1.826l-.007-.025v.011z",
    fill: "#F8D763"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M231.308 221.118l2.511 58.921a12.717 12.717 0 01-1.032 5.696c-2.733 6.31-9.025 21.48-5.928 20.597 3.096-.882 7.016-8.429 8.492-11.487.131-.272.533-.166.519.135-.303 5.589-1.239 25.717 1.282 23.348 2.924-2.748 3.591-18.543 3.591-18.543s-.727 20.739 2.935 20.305c2.546-.3 2.581-19.517 2.581-19.517s.554 20.837 3.524 19.517c2.867-1.271.417-19.517.417-19.517s.964 11.508 3.93 10.343c2.62-1.028-3.284-25.506-4.711-31.258a10.62 10.62 0 01-.31-2.472l1.168-61.782",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M231.308 221.118l2.511 58.921a12.717 12.717 0 01-1.032 5.696c-2.733 6.31-9.025 21.48-5.928 20.597 3.096-.882 7.016-8.429 8.492-11.487.131-.272.533-.166.519.135-.303 5.589-1.239 25.717 1.282 23.348 2.924-2.748 3.591-18.543 3.591-18.543s-.727 20.739 2.935 20.305c2.546-.3 2.581-19.517 2.581-19.517s.554 20.837 3.524 19.517c2.867-1.271.417-19.517.417-19.517s.964 11.508 3.93 10.343c2.62-1.028-3.284-25.506-4.711-31.258a10.62 10.62 0 01-.31-2.472l1.168-61.782M186.652 174.078l10.386 21.509 28.984-20.598",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M219.2 225.196l33.01-8.864-2.38-6.522-23.808-.388-6.822 15.774z",
    fill: "#16C8BB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.182 211.223l.946-10.781M213.691 263.421s8.097 3.422 6.032 13.998M282.288 230.726l10.424 25.399M196.504 266.434l-2.009 3.524M199.053 285.378l3.944 1.967",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M201.395 273.632a1.606 1.606 0 100-3.212 1.606 1.606 0 000 3.212zM205.811 281.799a1.606 1.606 0 100-3.212 1.606 1.606 0 000 3.212z",
    fill: "#333"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M205.711 273.896l.985 1.914",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M260.116 159.929s3.877-.911 4.52-6.272M247.116 175.924s3.224-.632 4.686-4.664",
    stroke: "#F8D763",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M245.432 137.785s-.974 4.022-5.84 10.569",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M202.381 140.278c.767-.964.727-2.273-.091-2.924-.818-.651-2.103-.397-2.871.567-.767.964-.727 2.274.091 2.925.818.651 2.103.397 2.871-.568zM186.229 131.731c.768-.965.727-2.274-.09-2.925-.818-.651-2.104-.397-2.871.567-.768.964-.727 2.274.091 2.925.818.651 2.103.397 2.87-.567z",
    fill: "#333"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M139.606 363.51c-3.883-3.442 2.944-11.412 3.985-18.922 1.098-7.88-.326-13.526-2.121-17.261-.319 9.681-3.486 17.159-4.847 18.979-.549.728-2.082 2.772-4.1 1.309-1.034-.753-1.404-2.28-1.123-3.653.287-1.373 1.009-2.605 1.475-3.921 1.635-4.547-1.028-11.195 1.749-19.235 2.057-5.939 8.066-11.048 8.066-11.048l-2.363-21.023 18.782 1.169.555 21.732s4.726 9.145 4.566 23.513c-.102 9.394-1.162 20.896-9.381 22.607-3.55 5.939-7.293 4.145-7.293 4.145-2.554 3.346-6.743 2.688-7.957 1.616l.007-.007z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M158.456 234l9.267 86.059H134.63l-10.39-56.306-9.662-31.669L158.456 234z",
    fill: "#008AE9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M125.159 237.551l9.553 23.265a233.593 233.593 0 0117.504 89.513l-.51 147.711H30.376l.696-208.142 36.778-57.82 57.309 5.467v.006z",
    fill: "#333"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.583 363.51c3.883-3.442-2.944-11.412-3.985-18.922-1.098-7.88.326-13.526 2.12-17.261.32 9.681 3.487 17.159 4.847 18.979.55.728 2.082 2.772 4.1 1.309 1.035-.753 1.405-2.28 1.124-3.653-.287-1.373-1.009-2.605-1.475-3.921-1.635-4.547 1.028-11.195-1.75-19.235-2.056-5.939-8.066-11.048-8.066-11.048l2.363-21.023-18.781 1.169-.556 21.732s-4.726 9.145-4.566 23.513c.102 9.394 1.163 20.896 9.381 22.607 3.551 5.939 7.293 4.145 7.293 4.145 2.555 3.346 6.744 2.688 7.957 1.616l-.006-.007z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M123.473 39.588s36.081 34 20.314 74.111c-.217-16.208-7.638-22.096-7.638-22.096s1.539 34.772-42.576 31.075c0 0-27.875 4.553-36.643-17.677-.716 8.723 4.374 13.341 4.374 13.341s-12.338-2.363-13.807-20.851c-1.207-15.244 3.053-44.78 23.17-58.854 32.651 3.308 52.806.951 52.806.951z",
    fill: "#333"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M96.537 108.245c-21.877 0-39.613-17.735-39.613-39.613 0-21.877 17.736-39.613 39.613-39.613 21.878 0 39.613 17.736 39.613 39.613 0 21.878-17.735 39.613-39.613 39.613z",
    fill: "#333"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.101 94.164l3.755 34a8.413 8.413 0 01-6.61 9.151l-5.025 11.176 29.235 15.716 31.573-21.483-13.794-8.002a8.41 8.41 0 01-7.478-8.168l-.453-19.72",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.101 94.164l3.755 34a8.412 8.412 0 01-6.61 9.151l-5.025 11.176 29.235 15.716 31.573-21.483-13.794-8.002a8.41 8.41 0 01-7.478-8.168l-.453-19.72",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M91.722 113.801c27.045 13.941 32.556-6.118 34.51-34.28 1.954-28.163-14.496-33.463-14.496-33.463L71.669 56.46 65.7 82.854",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M91.722 113.801c27.045 13.941 32.556-6.118 34.51-34.28 1.954-28.163-14.496-33.463-14.496-33.463L71.669 56.46 65.7 82.854",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M123.475 68.103s-8.104-5.805-12.517 3.398c-5.115 10.67 5.262 20.186 5.262 20.186l-4.534 5.805",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M123.475 68.103s-8.104-5.805-12.517 3.398c-5.115 10.67 5.262 20.186 5.262 20.186l-4.534 5.805",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M101.977 70.164s-8.29-5.952-18.188 5.582l18.188-5.582z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M101.977 70.164s-8.29-5.952-18.188 5.582",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M112.552 81.628c6.041-6.89 10.39-1.168 10.39-1.168l2.216-1.182",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M112.552 81.628c6.041-6.89 10.39-1.168 10.39-1.168l2.216-1.182",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M102.591 82.172s-6.067-5.052-12.108 1.845L86.6 82.996",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M102.591 82.172s-6.067-5.052-12.108 1.845L86.6 82.996",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M99.68 87.382c-1.03 0-1.866-1.521-1.866-3.398 0-1.876.835-3.397 1.865-3.397s1.865 1.521 1.865 3.397c0 1.877-.835 3.398-1.865 3.398zM119.616 84.637c-1.03 0-1.865-1.522-1.865-3.398 0-1.876.835-3.397 1.865-3.397s1.864 1.52 1.864 3.397c0 1.876-.834 3.398-1.864 3.398zM101.134 103.814c0 2.452 3.148 4.444 7.038 4.444 3.889 0 7.037-1.992 7.037-4.444 0-2.453-2.65-2.037-6.539-2.037-3.89 0-7.536-.416-7.536 2.037zM116.507 44.686s-15.014 32.263-42.768 35.705c-12.434-3.934-10.352-9.605-10.352-9.605l5.02-16.074 42.071-11.725 6.029 1.705v-.006z",
    fill: "#333"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M80.028 83.175c-3.608-6.201-10.217-9.094-14.758-6.45-4.54 2.644-5.3 9.815-1.692 16.016 3.608 6.2 10.218 9.094 14.758 6.45",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M80.028 83.175c-3.608-6.201-10.217-9.094-14.758-6.45-4.54 2.644-5.3 9.815-1.692 16.016 3.608 6.2 10.218 9.094 14.758 6.45",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M75.941 86.974s-4.604-8.622-10.25-3.404l10.25 3.404z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M75.941 86.974s-4.604-8.622-10.25-3.404",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 94.713s-8.001-5.09-4.406-12.81l4.406 12.81z",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M73.738 94.713s-8.001-5.09-4.406-12.81",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M112.496 124.747l-37.04.741.486 7.408-12.625 3.02c-22.224 5.314-38.151 24.836-38.892 47.673L20 320.059h38.789l-.466-93.466.562 20.563c39.095 15.754 70.004 0 70.004 0l30.379-3.736-6.763-78.945c-1.252-14.573-11.872-26.617-26.171-29.683l-13.985-2.995.153-7.044-.006-.006z",
    fill: "#008AE9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "thirdFormat_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 101,
    width: 15,
    height: 8
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M101.135 103.813c0 2.452 3.148 4.444 7.037 4.444 3.89 0 7.038-1.992 7.038-4.444 0-2.453-2.65-2.037-6.539-2.037-3.89 0-7.536-.416-7.536 2.037z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#thirdFormat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.376 122.396a9.132 9.132 0 110-18.265 9.132 9.132 0 010 18.265z",
    fill: "#FF755F"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M134.471 171.825l-1.271 4.566s13.437 18.003 0 33.981c2.944 23.073-4.317 36.784-4.317 36.784M58.878 189.981l-.09 130.079M109.27 270.369c-1.781 0-3.225-2.962-3.225-6.616 0-3.654 1.444-6.616 3.225-6.616 1.781 0 3.225 2.962 3.225 6.616 0 3.654-1.444 6.616-3.225 6.616zM117.241 255.018s2.095 60.348-16.221 84.047v151.159M82.09 257.137s-3.02 18.021-19.387 18.781M211.799 67.291c.425.125.318.749-.133.751-7.613.207-14.423 5.014-16.934 11.923-.162.405-.799.34-.787-.107.068-7.222-4.728-13.503-11.915-15.612-.424-.125-.318-.749.134-.751 7.613-.207 14.422-5.014 16.934-11.923.161-.405.799-.34.786.107-.068 7.222 4.728 13.503 11.915 15.612zM188.453 89.306c.219-.014.288.287.07.359-3.502 1.33-5.805 4.607-5.716 8.129.01.211-.309.278-.388.08-1.278-3.274-4.623-5.328-8.35-5.117-.219.014-.288-.288-.07-.36 3.502-1.33 5.805-4.606 5.717-8.128-.011-.211.308-.279.387-.08 1.278 3.274 4.623 5.328 8.35 5.117z",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thirdFormat_svg__clip0_632_9274"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h336v304H0z"
  })))));
}
export default __webpack_public_path__ + "static/thirdFormat.73e34839.svg";
export { SvgThirdFormat as ReactComponent };